import { render } from "./random.vue?vue&type=template&id=67ffbc6c&scoped=true"
import script from "./random.vue?vue&type=script&lang=js"
export * from "./random.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-67ffbc6c"

export default script